import { Button } from "@fragments";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useRef } from "react";
import { useScreen } from 'Screen/ScreenContext';

import ArrowBackIosNewRoundedIcon from "@mui/icons-material/ArrowBackIosNewRounded";
import "./styles.scss";
import { MovieCreationRounded, SlowMotionVideoRounded } from "@mui/icons-material";

import { Text } from "@fragments";

export default function Hero({ info }) {
    const nav = useNavigate();
    const { slug } = useParams();

    function getMetrics() {
        const playlists = info?.content?.length || 0;

        let videos = 0;

        info?.content?.forEach(item => {
            if (item.single) {
                videos += 1;
            } else {
                videos += item.contents?.length || 0;
            }
        });

        return {
            playlists,
            videos,
        }
    }

    const { playlists, videos } = getMetrics();

    return (
        <div className="hero">
            <div className="title-box px-8">
                <Button
                    onClick={() => nav(`/${slug}`)}
                    color="overlay"
                    size="small"
                    startIcon={<ArrowBackIosNewRoundedIcon />}
                >
                    Voltar
                </Button>

                <Text.h1
                    value={info?.name}
                    className="section-title"
                />

                <Text.h4
                    value={info?.description?.text}
                    className="section-description"
                    maxLines={2}
                />

                <div className="section-metrics mt-2">
                    <div className="section-metric-item">
                        <SlowMotionVideoRounded />
                        <span className="metric-value">{playlists} playlists</span>
                    </div>
                    <div className="section-metric-item">
                        <MovieCreationRounded />
                        <span className="metric-value">{videos} vídeos</span>
                    </div>
                </div>
            </div>
            <Banner wide={info?.banner?.wide} condensed={info?.banner?.condensed} />

            <span className="banner-hero-shadow"></span>
        </div>
    );
}


function Banner({ wide, condensed }) {
    const wideRef = useRef(null);
    const condensedRef = useRef(null);
    const { bodyRef } = useScreen();

    useEffect(() => {
        const container = bodyRef?.current;
        if (!container) return;

        const handleScroll = () => {
            const offset = `translateY(${container.scrollTop * 0.5}px)`;
            if (wideRef.current) wideRef.current.style.transform = offset;
            if (condensedRef.current) condensedRef.current.style.transform = offset;
        };

        container.addEventListener('scroll', handleScroll, { passive: true });
        return () => container.removeEventListener('scroll', handleScroll);
    }, [bodyRef]);

    return (
        <div className="course-banner-container">
            {wide && <img ref={wideRef} src={wide} className="course-banner course-banner--wide" />}
            {condensed && <img ref={condensedRef} src={condensed} className="course-banner course-banner--condensed" />}
            <span className="banner-content-left-shadow"></span>
            <span className="banner-content-right-shadow"></span>
            <span className="banner-content-bottom-shadow"></span>
        </div>
    );
}